import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { RichTextContent } from "../../shared/RichTextContent";
import { parseJsonSafely } from "../../../lib/formatting-utils";

interface EnhancedAnalysisProps {
  analysis: {
    engagement?: any;
    actionItems?: any;
    summary?: any;
  };
  sentiment?: string | null;  // Updated to allow null
}

export function EnhancedAnalysis({ analysis, sentiment }: EnhancedAnalysisProps) {
  if (!analysis && !sentiment) return null;

  const parsedSentiment = parseJsonSafely(sentiment);

  return (
    <div className="space-y-6">
      {analysis?.summary && (
        <Card>
          <CardHeader>
            <CardTitle>Executive Summary</CardTitle>
          </CardHeader>
          <CardContent>
            <RichTextContent content={analysis.summary} />
          </CardContent>
        </Card>
      )}

      {parsedSentiment?.sentiment && (
        <Card>
          <CardHeader>
            <CardTitle>Sentiment Analysis</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">{parsedSentiment.sentiment}</p>
          </CardContent>
        </Card>
      )}

      {analysis?.engagement && (
        <Card>
          <CardHeader>
            <CardTitle>Engagement Analysis</CardTitle>
          </CardHeader>
          <CardContent>
            <RichTextContent content={analysis.engagement} />
          </CardContent>
        </Card>
      )}
    </div>
  );
}